// Design v8 Project team order: the server stores one list of member ids plus "__nobody" (`team_order`); the
// view-model keeps the reference's shape — `members` in team order and `noOnePos` (No one's index among them).
export const NOBODY = '__nobody';

/** Members ordered by the stored team order (unknown ids dropped, members missing from it appended). */
export function applyTeamOrder(members: string[], teamOrder: string[] | undefined): { members: string[]; noOnePos: number | null } {
  const ord = (teamOrder || []).filter(id => id === NOBODY || members.includes(id));
  const out = ord.filter(id => id !== NOBODY);
  for (const m of members) if (!out.includes(m)) out.push(m);
  const k = ord.indexOf(NOBODY);
  return { members: out, noOnePos: k < 0 ? null : k };
}

/** The reference's teamOrder(p): members with "__nobody" at noOnePos (default: last). */
export function teamOrderOf(p: { members: string[]; noOnePos?: number | null }): string[] {
  const m = p.members.slice(), k = p.noOnePos == null || p.noOnePos < 0 || p.noOnePos > m.length ? m.length : p.noOnePos;
  m.splice(k, 0, NOBODY);
  return m;
}
